import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-table-expandable', 'expandRow', 'Näita rida');
Labels.set('ui-table-expandable', 'collapseRow', 'Peida rida');
